module.exports = __webpack_public_path__ + "img/binary-slash.82a2c8a6.svg";